import React, { Component } from 'react';

import './Popup.css';

import PropTypes from 'prop-types';

import Button from '../Button/Button';

const classNames = require('classnames');

export class Popup extends Component {
    render() {
        if (this.props.show === true)
            return (
                <div className={classNames('upbox-popup-wrapper', this.props.type, this.props.className)}>
                    <div className={classNames('upbox-popup', { 'upbox-popup-big': this.props.bigPopup === true })}>
                        {
                            this.props.renderHeader ?
                                <div className="upbox-popup-header">
                                    {this.props.renderHeader()}
                                </div>
                                :
                                <div className="upbox-popup-header">
                                    {/* <span className="upbox-popup-header-span">{this.props.header}</span> */}
                                    {
                                        this.props.header &&
                                this.props.headerButtons.map((x, i) => (
                                    <Button
                                        key={i}
                                        {...x}/>
                                ))
                                    }
                                </div>
                        }
                        <div className="upbox-popup-content">
                            {
                                this.props.renderContent ?
                                    this.props.renderContent()
                                    :
                                    this.props.text
                            }
                        </div>
                        <div className="upbox-popup-footer">
                            {
                                this.props.renderFooter ?
                                    this.props.renderFooter()
                                    :
                                    this.props.footerButtons.map((x, i) => (
                                        <Button
                                            key={i}
                                            {...x}/>
                                    ))
                            }
                        </div>
                    </div>
                </div>
            );
        return null;
    }
}

Popup.defaultProps = {
    show: false,
    header: null,
    text: null,
    headerButtons: [],
    footerButtons: [],
    renderHeader: null,
    renderContent: null,
    renderFooter: null,
    color: '#333',
};
Popup.propTypes = {
    show: PropTypes.bool,
    bigPopup: PropTypes.bool,
    header: PropTypes.string,
    text: PropTypes.string,
    headerButtons: PropTypes.array,
    footerButtons: PropTypes.array,
    renderHeader: PropTypes.func,
    renderContent: PropTypes.func,
    renderFooter:PropTypes.func,
    color: PropTypes.string,
    className: PropTypes.string,
    type:PropTypes.string,
};

export default Popup;
